import * as React from 'react';
import { StickyActionBar } from '../../../components/sticky-action-bar/StickyActionBar';
import { ShipmentType } from '../../models/enums/shipment-type';
import { RunningTotal } from '../../models/shared/running-total';

interface IProps {
    entityType: ShipmentType;
    totals: RunningTotal;
    showBar?: boolean;
}

/**
 * The truck/container totals bar shown at the bottom of the stop flyouts
 */
export const ShipmentTruckTotalsBar = (props: IProps) => {

    const totals = props.totals;

    return <StickyActionBar
        classes="stopaction-add-orders"
        showBar={props.showBar !== false}>

        <div className="running-total-bar">
            <p className="row-label">
                {
                    props.entityType === ShipmentType.Truck
                        ? "Truck Totals"
                        : "Container Totals"
                }
            </p>
            <div>
                <p className={`rollup-metric ${totals.getUnitWarning()}`}>
                    <span>Units</span>
                    <span>{totals.units}</span>
                </p>
                <p className={`rollup-metric ${totals.getWeightWarning()}`}>
                    <span>Weight</span>
                    <span>{totals.weight}</span>
                </p>
                <p className="rollup-metric">
                    <span>Singles</span>
                    <span>{totals.singles}</span>
                </p>
                <p className="rollup-metric">
                    <span>Sections</span>
                    <span>{totals.sections}</span>
                </p>
                <p className="rollup-metric">
                    <span>Track</span>
                    <span>{totals.track}</span>
                </p>
                <p className="rollup-metric">
                    <span>Hardware</span>
                    <span>{totals.hardware}</span>
                </p>
            </div>
        </div>
    </StickyActionBar>;
};
